import { render, staticRenderFns } from "./DonorReport.vue?vue&type=template&id=b674976a&scoped=true&"
import script from "./DonorReport.vue?vue&type=script&lang=js&"
export * from "./DonorReport.vue?vue&type=script&lang=js&"
import style0 from "./DonorReport.vue?vue&type=style&index=0&id=b674976a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b674976a",
  null
  
)

export default component.exports